import React, { useState } from 'react';
import { CheckboxGroupStyled } from './CheckboxGroupStyled';

const CheckboxGroup = ({ questions, setCheckboxGroupData, eveId, disabled }) => {
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedCheckboxes([...selectedCheckboxes, value]);
    } else {
      setSelectedCheckboxes(selectedCheckboxes.filter((item) => item !== value));
    }
  };
  
  React.useEffect(() => {
    if (selectedCheckboxes.length === 0) {
      setCheckboxGroupData(null);
    } else if (selectedCheckboxes.length > 0) {
        const newData = {
          questionId: questions?.questionId,
          answer: selectedCheckboxes,
          eventId: eveId,
        };
        setCheckboxGroupData(newData);

    }
  }, [selectedCheckboxes]);

  return (
    <CheckboxGroupStyled>
      <div className="npsQuestion">{questions?.questionTitle}</div>
      <div className="checkbox-container">
        {questions?.options?.map((option, index) => (
          <label key={index} htmlFor={`checkbox-${index}`} className={`checkBox-label 
          ${selectedCheckboxes?.includes(option?.optionName) ? 'checkBox-checked' : ''} ${disabled ? 'disable' : ''}`}>
            <input
              type="checkbox"
              id={`checkbox-${index}`}
              value={option?.optionName}
              onChange={handleCheckboxChange}
              checked={selectedCheckboxes?.includes(option?.optionName)}
              className="checkbox-input"
            />
            {option?.optionName}
          </label>
        ))}
      </div>
    </CheckboxGroupStyled>
  );
};

export default CheckboxGroup;
